


















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Chapter from '../../interfaces/models/Chapter';
import Flow from '../../interfaces/models/Flow';
import Slide from '../../interfaces/models/Slide';
import draggable from 'vuedraggable';
import PresentationItem from '@/components/presentation/PresentationItem.vue';
import PresentationFilterMenu from '@/components/presentation/PresentationFilterMenu.vue';
import PresentationSlideCard from '@/components/presentation/PresentationSlideCard.vue';

@Component({
  components: { PresentationSlideCard, PresentationItem, draggable, PresentationFilterMenu }
})
export default class PresentationFilter extends Vue {
  @Prop({ required: true }) flows!: Flow[];
  @Prop({ required: true }) chapters!: Chapter[];
  @Prop({ required: true }) slides!: Slide[];

  search = '';
  selectedFlows: string[] = [];
  selectedChapters: string[] = [];

  get flowLabel() {
    return this.selectedFlows.length ? `Flows (${this.selectedFlows.length})` : 'Flows';
  }

  get chapterLabel() {
    return this.selectedChapters.length ? `Chapters (${this.selectedChapters.length})` : 'Chapters';
  }

  get flowList() {
    return this.flows.map(({ name, _id }) => ({
      label: name,
      value: _id
    }));
  }

  get chapterList() {
    return this.chapters.map(({ name, _id }) => ({
      label: name,
      value: _id
    }));
  }

  get presentationSelection() {
    return { flow: this.selectedFlows, chapter: this.selectedChapters, wildcard: this.search };
  }

  get slidesCopy() {
    return [...this.slides];
  }

  @Watch('presentationSelection')
  @Emit('filter-change')
  onPresentationSelectionChange() {
    return this.presentationSelection;
  }

  reset() {
    this.search = '';
    this.selectedFlows = [];
    this.selectedChapters = [];
  }
}
